/**
 * Utility function to map role name to role_id, to search for feature settings
 * @param {string} role - logged in user's role
 * @returns {number} - role id of given role
 */

const roleNameIdMap = (role: string): number => {
    switch (role) {
        case "dev":
            return 4;
        case "oem":
            return 2;
        case "tester":
            return 5;
        case "user":
            return 3;
        default:
            return -1;
    }
};

export { roleNameIdMap };
